<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i> 返回
        </div>
        <el-card class="box-card">
            <template #header>
                <div class="card-header" style="display: flex;justify-content: space-between;align-items: center;">
                    <h1>用户信息</h1>
                    <div>
                        <el-button type="primary" :loading="freeTrialSubmitting" :disabled="!uid"
                            @click="setFreeTrialUser" text>设置14天免费试用</el-button>
                        <el-button type="primary" @click="SyncTomeZone()" text>同步时区</el-button>
                    </div>
                </div>
            </template>

            <el-form ref="userform" :model="userform" style="width:100%" :inline="true" label-width="140px">
                <el-form-item label="用户唯一编码" label-width="160px">
                    <el-input disabled v-model="userform.uid"></el-input>
                </el-form-item>
                <el-form-item label="昵称" label-width="160px">
                    <el-input disabled v-model="userform.nickname"></el-input>
                </el-form-item>
                <el-form-item label="注册国家" label-width="160px">
                    <el-input disabled v-model="userform.register_country"></el-input>
                </el-form-item>
                <el-form-item label="注册IP" label-width="160px">
                    <el-input disabled v-model="userform.register_ip"></el-input>
                </el-form-item>
                <el-form-item label="注册时间" label-width="160px">
                    <el-input disabled v-model="userform.register_time"></el-input>
                </el-form-item>
                <el-form-item label="账号类型" label-width="160px">
                    <el-input disabled v-model="accountType[userform.account_type]"></el-input>
                </el-form-item>
                <el-form-item label="头像地址" label-width="160px">
                    <el-input disabled v-model="userform.avatar"></el-input>
                </el-form-item>
                <el-form-item label="应用标志" label-width="160px">
                    <el-input disabled v-model="userform.schema"></el-input>
                </el-form-item>
                <el-form-item label="涂鸦区域" label-width="160px">
                    <el-input disabled v-model="userform.tuya_region"></el-input>
                </el-form-item>
                <el-form-item label="涂鸦uid" label-width="160px">
                    <el-input disabled v-model="userform.tuya_uid"></el-input>
                </el-form-item>
                <el-form-item label="更新时间" label-width="160px">
                    <el-input disabled v-model="userform.update_time"></el-input>
                </el-form-item>
                <el-form-item label="账号删除时间" label-width="160px">
                    <el-input disabled v-model="userform.delete_time"></el-input>
                </el-form-item>
                <el-form-item label="启用Alexa" label-width="160px">
                    <el-input disabled v-model="alexaText"></el-input>
                </el-form-item>
                <el-form-item label="启用Google Home" label-width="160px">
                    <el-input disabled v-model="googleHomeText"></el-input>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <h1>登录列表</h1>
                </div>
            </template>
            <el-table border v-bind:data="loginlist">
                <el-table-column label="app的包名">
                    <template v-slot="scope">
                        <span>{{ scope.row.app_package_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="APP版本">
                    <template v-slot="scope">
                        <span>{{ scope.row.app_version }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="国家码">
                    <template v-slot="scope">
                        <span>{{ scope.row.country_code }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备的手机品牌">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_brand }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备的唯一标志">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_code }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="国家语言">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_language }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备的手机型号">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_model }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备的系统版本">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_system_version }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备类型">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.device_type == 1
                                ? '安卓'
                                : scope.row.device_type == 2
                                    ? 'IOS'
                                    : '未知'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备的时区">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_zone }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="access_token过期的UTC时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.expires_in) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="应用唯一编码">
                    <template v-slot="scope">
                        <span>{{ scope.row.schema }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="最近登陆时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.login_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备的手机屏幕">
                    <template v-slot="scope">
                        <span>{{ scope.row.phone_screen }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备的推送token">
                    <template v-slot="scope">
                        <el-button size="mini" @click="Looktoken(scope.row.push_token)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="设备的推送类型">
                    <template v-slot="scope">
                        <span>{{ changePushType(scope.row.push_type) }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <h1>信任设备列表</h1>
                </div>
            </template>
            <el-table border v-bind:data="trustDevlist">
                <el-table-column label="用户唯一编码">
                    <template v-slot="scope">
                        <span>{{ scope.row.uid }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="登录设备唯一编码">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_code }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="添加时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.create_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="手机品牌">
                    <template v-slot="scope">
                        <span>{{ scope.row.phone_brand }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="手机型号">
                    <template v-slot="scope">
                        <span>{{ scope.row.phone_model }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <h1>用户绑定的涂鸦设备</h1>
                </div>
            </template>
            <el-table border v-bind:data="tuyalist">
                <el-table-column label="设备id">
                    <template v-slot="scope">
                        <span>{{ scope.row.id }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备uuid">
                    <template v-slot="scope">
                        <span>{{ scope.row.uuid }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称">
                    <template v-slot="scope">
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="product_id">
                    <template v-slot="scope">
                        <span>{{ scope.row.product_id }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属产品型号">
                    <template v-slot="scope">
                        <span>{{ scope.row.model }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="serve_ip">
                    <template v-slot="scope">
                        <span>{{ scope.row.ip }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="在线状态">
                    <template v-slot="scope">
                        <span v-if="scope.row.online == 1" style="color:green">在线</span>
                        <span v-else style="color:red">不在线</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备上次配网时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.active_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                    <template v-slot="scope">
                        <el-button type="info" size="mini" @click="TuyaInfo(scope.row)">详情</el-button>
                        <el-button type="info" size="mini" @click="TuyaLog(scope.row)">日志</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <h1>用户与app关系列表</h1>
                </div>
            </template>
            <el-table border v-bind:data="list">
                <el-table-column label="活动推送">
                    <template v-slot="scope">
                        <el-button v-if="scope.row.active_push == 1" type="success" size="mini" @click="
                            changeStatus('active_push', scope.row, true)
                            ">接收</el-button>
                        <el-button v-else type="danger" size="mini" @click="
                            changeStatus('active_push', scope.row, false)
                            ">不接收</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="双重认证">
                    <template v-slot="scope">
                        <el-button v-if="scope.row.auth_tow == 1" type="success" size="mini"
                            @click="changeStatus('auth_tow', scope.row, true)">开启</el-button>
                        <el-button disabled v-else type="danger" size="mini"
                            @click="changeStatus('auth_tow', scope.row, false)">不开启</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="debug用户">
                    <template v-slot="scope">
                        <el-button v-if="scope.row.is_debug == 1" type="success" size="mini"
                            @click="changeStatus('is_debug', scope.row, true)">是</el-button>
                        <el-button v-else type="danger" size="mini"
                            @click="changeStatus('is_debug', scope.row, false)">不是</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="开发者">
                    <template v-slot="scope">
                        <el-button v-if="scope.row.is_developer == 1" type="success" size="mini" @click="
                            changeStatus('is_developer', scope.row, true)
                            ">是</el-button>
                        <el-button v-else type="danger" size="mini" @click="
                            changeStatus('is_developer', scope.row, false)
                            ">不是</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="测试用户">
                    <template v-slot="scope">
                        <el-button v-if="scope.row.is_test == 1" type="success" size="mini"
                            @click="changeStatus('is_test', scope.row, true)">是</el-button>
                        <el-button v-else type="danger" size="mini"
                            @click="changeStatus('is_test', scope.row, false)">不是</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="首次登陆时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.login_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="应用唯一编码">
                    <template v-slot="scope">
                        <span>{{ scope.row.schema }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                    <template v-slot="scope">
                        <el-button v-if="scope.row.is_debug == 1" size="mini" type="info"
                            @click="AppLog(scope.row)">App日志</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <h1>用户绑定设备列表</h1>
                </div>
            </template>
            <el-table border v-bind:data="bindlist" size="small">
                <!-- <el-table-column label="设备编号">
                    <template v-slot="scope">
                        <span>{{ scope.row.device_id }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="设备uuid">
                    <template v-slot="scope">
                        <span>{{ scope.row.uuid }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称">
                    <template v-slot="scope">
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否绑定">
                    <template v-slot="scope">
                        <span style="color:green" v-if="scope.row.status == 1">{{ '已绑定' }}</span>
                        <span style="color:red" v-else-if="scope.row.status == 2">{{ '已解绑' }}</span>
                        <span v-else>{{ '未知' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="绑定关系">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.bind_type == 1
                                ? '主人'
                                : scope.row.bind_type == 2
                                    ? '分享'
                                    : '未知'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="内部型号">
                    <template v-slot="scope">
                        <span>{{ scope.row.model }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备关系排序">
                    <template v-slot="scope">
                        <span>{{ scope.row.sort }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="休眠/p2p在线状态">
                    <template v-slot="scope">
                        <span style="color:green" v-if="scope.row.open_status == 1">在线/</span>
                        <span style="color:red" v-else>不在线/</span>
                        <span style="color:green" v-if="scope.row.p2p_online == 1">在线</span>
                        <span style="color:red" v-else>不在线</span>
                    </template>
                </el-table-column>
                <el-table-column label="邀评状态">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.comment_status === 1
                                ? '已评论'
                                : scope.row.comment_status === 2
                                    ? '已弹窗'
                                    : '未弹窗'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="绑定时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.bind_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="解绑时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.delete_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="第一次绑定时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.first_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="440px">
                    <template v-slot="scope">
                        <router-link :to="'/iot/onlineinfo/' +
                            scope.row.uuid +
                            '@' +
                            params
                            " style="margin-right:10px">
                            <el-button type="info" size="mini">详情</el-button>
                        </router-link>
                        <el-button type="danger" v-if="scope.row.status == 1" size="mini"
                            @click="unbinding(scope.row)">取消绑定</el-button>
                        <el-button v-if="scope.row.status == 1" type="info" size="mini"
                            @click="CreateCloud(scope.row)">开通套餐</el-button>
                        <el-button type="info" size="mini" @click="GetCloudInfo(scope.row)">云存储</el-button>
                        <el-button type="info" size="mini" style="margin-top: 2px;" @click="UserDeviceShadow(scope.row)"
                            v-if="(scope.row.online_type === 1 || isHuntingDevice(scope.row)) && scope.row.bind_type === 1">设备影子</el-button>
                        <el-button v-if="isSimdataModel(scope.row)" type="info"
                            size="mini" @click="GetSimdataList(scope.row)">4G套餐</el-button>
                        <el-button v-if="isSimdataModel(scope.row)" type="info"
                            size="mini" @click="OpenSimdata(scope.row)">开通4G套餐</el-button>
                        <el-button v-if="isHuntingDevice(scope.row)" type="info" size="mini"
                            style="margin-top: 2px;" @click="GetHuntingCloudInfo(scope.row)">猎机套餐</el-button>
                        <el-button v-if="isHuntingDevice(scope.row)" type="info" size="mini"
                            style="margin-top: 2px;" @click="OpenHuntingCreate(scope.row)">开通猎机套餐</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-card class="box-card">
            <template #header>
                <div class="card-header" style="display: flex;justify-content: space-between;align-items: center;">
                    <h1>用户套餐管理</h1>
                    <div>
                        <!-- <el-button type="primary" size="mini" @click="GetUserPackageList()">查询</el-button> -->
                        <el-button type="primary" size="mini" @click="OpenUserPackage()">开通套餐</el-button>
                    </div>
                </div>
            </template>
            <el-table border v-bind:data="userPackageList" size="small">
                <el-table-column label="订阅编号" min-width="160" show-overflow-tooltip prop="subscribe_id"></el-table-column>
                <el-table-column label="订单编号" min-width="130" show-overflow-tooltip prop="order_id"></el-table-column>
                <el-table-column label="套餐名称" min-width="150" show-overflow-tooltip prop="product_name"></el-table-column>
                <el-table-column label="云存储天数" min-width="90" prop="file_time"></el-table-column>
                <el-table-column label="云存储类型" min-width="90">
                    <template v-slot="scope">
                        <span>{{ scope.row.is_event == 0 ? '全时' : scope.row.is_event == 1 ? '事件' : '未知' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="等级" min-width="100" show-overflow-tooltip>
                    <template v-slot="scope">
                        <span>{{ getLevelName(scope.row.level) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="支持设备数" min-width="90" show-overflow-tooltip>
                    <template v-slot="scope">
                        <span>{{ scope.row.support_dev_num }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否删除" min-width="80">
                    <template v-slot="scope">
                        <span style="color:red" v-if="scope.row.is_delete == 1">已删除</span>
                        <span v-else>未删除</span>
                    </template>
                </el-table-column>
                <el-table-column label="订阅状态" min-width="80">
                    <template v-slot="scope">
                        <span>{{ getUserPackageStatusText(scope.row.subscribe_status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="开始时间" min-width="155">
                    <template v-slot="scope">
                        <span>{{ formatPackageTime(scope.row.start_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间" min-width="155">
                    <template v-slot="scope">
                        <span>{{ formatPackageTime(scope.row.end_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="服务内容" min-width="160" show-overflow-tooltip>
                    <template v-slot="scope">
                        <span>{{ scope.row.service }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="360" fixed="right">
                    <template v-slot="scope">
                        <div style="white-space: nowrap;">
                            <el-button size="mini" type="info" @click="OpenUserPackageDeviceList(scope.row)">设备</el-button>
                            <el-button size="mini" type="info" v-if="!scope.row.is_delete && scope.row.end_time > Math.floor(Date.now() / 1000)" @click="OpenUserPackageDeviceAdd(scope.row)">添加设备</el-button>
                            <el-button size="mini" type="info" v-if="scope.row.subscribe_status === 1" @click="CancelUserPackageRenew(scope.row)">取消续订</el-button>
                            <el-button size="mini" type="info" v-if="!scope.row.is_delete && scope.row.end_time > Math.floor(Date.now() / 1000)" @click="ShutdownUserPackage(scope.row)">关闭套餐</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @current-change="handleUserPackagePageChange" v-model:currentPage="userPackageSearch.page"
                :page-size="userPackageSearch.limit" layout="total, prev, pager, next" :total="userPackageTotal" background
                style="margin-top:10px">
            </el-pagination>
        </el-card>

        <el-card class="box-card">
            <template #header>
                <div class="card-header">
                    <h1>（亚马逊）订单列表</h1>
                </div>
            </template>
            <el-table border v-bind:data="warrantyOrderList">
                <el-table-column label="渠道" width="80px">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.channel === 1 ? '亚马逊' : '其他'
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单号" width="180px">
                    <template v-slot="scope">
                        <span>{{ scope.row.order_no }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单联系邮箱" width="190px">
                    <template v-slot="scope">
                        <span>{{ scope.row.email }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备型号">
                    <template v-slot="scope">
                        <span>{{ scope.row.model_code }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="uuid">
                    <template v-slot="scope">
                        <span>{{ scope.row.uuid }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="180px">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.create_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注" show-overflow-tooltip>
                    <template v-slot="scope">
                        <span>{{ scope.row.remark }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                    <template v-slot="scope">
                        <el-button type="info" size="mini" @click="openAmazonRemark(scope.row)">备注</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog v-model="amazonRemarkDialog" :modal="true" :append-to-body="true" title="修改备注" width="30%">
                <el-form class="modify-uuid">
                    <el-form-item label="" prop="pass">
                        <el-input v-model="amazonRemark" :rows="4" type="textarea" placeholder="" />
                    </el-form-item>
                </el-form>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="amazonRemarkDialog = false">取消</el-button>
                        <el-button type="primary" @click="updateAmazonRemark()">确定</el-button>
                    </span>
                </template>
            </el-dialog>
        </el-card>
        <el-dialog title="开通云存储情况" v-model="cloudFormVisible" width="1400px" center size="small">
            <el-table border v-bind:data="cloudList">
                <el-table-column label="订单id">
                    <template v-slot="scope">
                        <span>{{ scope.row.order_id }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备uuid">
                    <template v-slot="scope">
                        <span>{{ scope.row.uuid }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐开始时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.start_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐结束时间">
                    <template v-slot="scope">
                        <span>{{ changeTime(scope.row.end_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐内云存储时间(天)">
                    <template v-slot="scope">
                        <span>{{ scope.row.file_time }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.status == 0
                                ? '未订阅'
                                : scope.row.status == 1
                                    ? '已订阅'
                                    : '未知'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否删除" width="90">
                    <template v-slot="scope">
                        <span style="color:red" v-if="scope.row.is_delete == 1">{{ '已删除' }}</span>
                        <span v-else-if="scope.row.is_delete == 0">{{ '未删除' }}</span>
                        <span v-else>{{ '未知' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否过期" width="90">
                    <template v-slot="scope">
                        <span style="color:red" v-if="scope.row.is_expired">{{ '已过期' }}</span>
                        <span v-else>{{ '未过期' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="云存储事件类型">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.is_event == 0
                                ? '全时'
                                : scope.row.is_event == 1
                                    ? '事件'
                                    : '未知'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订阅的app">
                    <template v-slot="scope">
                        <span>{{ scope.row.schema }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="400px">
                    <template v-slot="scope">
                        <el-button size="small" v-if="scope.row.file_time !== 0" type="text"
                            @click="S3KeyAnalyse(scope.row)">S3key分析</el-button>
                        <el-button size="small" v-if="scope.row.status != 0" type="info"
                            @click="cancelCloudRenew(scope.row)">取消续订</el-button>
                        <el-button size="small" v-if="!(scope.row.is_delete || scope.row.is_expired)" type="info"
                            @click="closeCloud(scope.row)">关闭云存储</el-button>
                        <el-button size="small" v-if="!(scope.row.is_delete || scope.row.is_expired)" type="info"
                            @click="migrateCloud(scope.row)">迁移云存储</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cloudFormVisible = false">取消</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="4G套餐" v-model="simdataShow" width="1200px" center>
            <el-table border v-bind:data="simdataList" size="small" height="520">
                <el-table-column label="订单号" width="140">
                    <template v-slot="scope">
                        <span>{{ scope.row.order_id }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订阅编号" width="100">
                    <template v-slot="scope">
                        <span>{{ scope.row.subscribe_id }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="用户UID" width="150">
                    <template v-slot="scope">
                        <span>{{ scope.row.uid }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="SIM ID" width="120">
                    <template v-slot="scope">
                        <span>{{ scope.row.sim_id }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="IMEI" width="130">
                    <template v-slot="scope">
                        <span>{{ scope.row.imei }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐名称" width="140">
                    <template v-slot="scope">
                        <span>{{ scope.row.package_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="套餐编码" width="140">
                    <template v-slot="scope">
                        <span>{{ scope.row.package_code }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="90">
                    <template v-slot="scope">
                        <span>{{ getSimdataStatusText(scope.row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="开始时间" width="100">
                    <template v-slot="scope">
                        <span>{{ scope.row.start_time ? util.dateFormat(scope.row.start_time) : '--:--:--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间" width="100">
                    <template v-slot="scope">
                        <span>{{ scope.row.end_time ? util.dateFormat(scope.row.end_time) : '--:--:--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="流量上限" width="100">
                    <template v-slot="scope">
                        <span>{{ formatDataLimitKb(scope.row.data_limit) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="已用流量" width="100">
                    <template v-slot="scope">
                        <span>{{ formatDataLimitKb(scope.row.data_used) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220">
                    <template v-slot="scope">
                        <el-button size="mini" type="info" v-if="scope.row.is_sub"
                            @click="cancelSimdataRenew(scope.row)">取消4G套餐续订</el-button>
                        <el-button size="mini" type="info"
                            v-if="((scope.row.status === 0 || scope.row.status === 1) && scope.row.end_time > Math.floor(Date.now() / 1000))"
                            @click="openSimdataClose(scope.row)">关闭4G套餐</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="simdataShow = false">取消</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="开通4G套餐" v-model="simdataOpenVisible" width="30%" center>
            <el-form label-width="100px" ref="simdataOpenFormRef" :model="simdataOpenForm" :rules="simdataOpenRules">
                <el-form-item label="UUID" prop="uuid">
                    <el-input disabled v-model="simdataOpenForm.uuid" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="UID" prop="uid">
                    <el-input disabled v-model="simdataOpenForm.uid" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="品牌appid" prop="schema">
                    <el-select v-model="simdataOpenForm.schema">
                        <el-option v-for="item in brandlist" :key="item.code" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐" prop="package_code">
                    <el-select v-model="simdataOpenForm.package_code" filterable>
                        <el-option v-for="item in simdataPackList" :key="item.code" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="simdataOpenVisible = false">取消</el-button>
                    <el-button @click="ValidateSimdataOpen()">确认</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="关闭4G套餐" v-model="simdataCloseVisible" width="300px" center>
            <div class="close_cloud">
                <select v-model="simdataReturnMoney" class="close_cloud_select">
                    <option :value="1">退款</option>
                    <option :value="2">不退款</option>
                </select>
                <div class="dialog-footer">
                    <el-button @click="confirmSimdataClose()">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="关闭云存储" v-model="isShowCloseCloudDialog" width="300px" center>
            <div class="close_cloud">
                <select v-model="isReturnMoney" class="close_cloud_select">
                    <option :value="1">退款</option>
                    <option :value="2">不退款</option>
                </select>
                <div class="dialog-footer">
                    <el-button @click="closelCloudConfirm()">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="迁移云存储" v-model="isShowMigrateCloudDialog" width="300px" center>
            <div class="close_cloud">
                <el-input v-model="migrateUuid" autocomplete="off" placeholder="uuid"
                    style="margin-bottom: 20px;"></el-input>
                <div class="dialog-footer">
                    <el-button @click="migrateCloudConfirm()">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- s3key分析 -->
        <el-dialog title="S3key分析" v-model="s3FormVisible" width="1000px" center>
            <el-form :model="s3form" :inline="true" class="demo-form-inline" :rules="s3formrules" ref="logform">
                <el-form-item label="日期" prop="date" label-width="60px">
                    <el-date-picker v-model="s3form.date" type="date" placeholder="Pick a Date" @change="GetS3key">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <el-form v-if="formVisibl" :model="analyseform" :inline="true" class="demo-form-inline">
                <el-form-item label="文件位置:" label-width="100px">
                    <el-input disabled style="width:200px" v-model="analyseform.file_brand" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="版本:" label-width="100px">
                    <el-input disabled style="width:200px" v-model="analyseform.version" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="区域:" label-width="100px">
                    <el-input disabled style="width:200px" v-model="analyseform.region" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="文件目录:" label-width="100px">
                    <el-input disabled style="width:620px" v-model="analyseform.file_key" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="品牌分析:" label-width="100px">
                    <el-input disabled style="width:620px" v-model="analyseform.brand_equal" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="目录分析:" label-width="100px">
                    <el-input disabled style="width:620px" v-model="analyseform.key_appid_right"
                        placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="位置分析:" label-width="100px">
                    <el-input disabled style="width:620px" v-model="analyseform.key_brand_right"
                        placeholder=""></el-input>
                </el-form-item>
            </el-form>
            <el-table border v-bind:data="s3KeyList">
                <el-table-column label="key">
                    <template v-slot="scope">
                        <span>{{ scope.row.key }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="开通套餐" v-model="packFormVisible" width="30%" center>
            <el-form label-width="80px" ref="creatcloudform" :model="creatcloudform" :rules="rules">
                <el-form-item label="套餐" prop="product_id">
                    <el-select v-model="creatcloudform.product_id" filterable>
                        <el-option v-for="item in packList" :key="item.SetMeal.code" :label="item.SetMeal.name"
                            v-show="item.SetMeal.status !== 3" :value="item.SetMeal.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐时长" prop="cycle">
                    <el-input-number v-model="creatcloudform.cycle" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="终端编号" prop="app_id">
                    <el-select v-model="creatcloudform.app_id">
                        <el-option v-for="item in brandlist" :key="item.code" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="packFormVisible = false">取消</el-button>
                    <el-button @click="Validate(CreateConfirm)">确认</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 开通猎机套餐 -->
        <el-dialog title="开通猎机套餐" v-model="huntingCreateVisible" width="30%" center>
            <el-form v-loading="huntingCreateLoading" label-width="100px" ref="huntingCreateFormRef"
                :model="huntingCreateForm" :rules="huntingCreateRules">
                <el-form-item label="UUID" prop="uuid">
                    <el-input disabled v-model="huntingCreateForm.uuid" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="UID" prop="uid">
                    <el-input disabled v-model="huntingCreateForm.uid" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备型号">
                    <el-input disabled v-model="huntingCreateForm.model_code" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="终端编号" prop="app_id">
                    <el-select v-model="huntingCreateForm.app_id">
                        <el-option v-for="item in brandlist" :key="item.code" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐" prop="package_code">
                    <el-select v-model="huntingCreateForm.package_code" filterable style="width:100%">
                        <el-option v-for="item in huntingPackList" :key="item.code" :label="huntingPackageLabel(item)"
                            :value="item.code"></el-option>
                    </el-select>
                    <div v-if="!huntingCreateLoading && huntingPackList.length === 0"
                        style="color:#e6a23c;font-size:12px;line-height:20px">
                        该设备型号暂无可开通的套餐，请先在猎机套餐管理中关联型号
                    </div>
                </el-form-item>
                <el-form-item label="备注" prop="description">
                    <el-input v-model.trim="huntingCreateForm.description" type="textarea" :rows="2" maxlength="200"
                        show-word-limit placeholder="如：客服代开通"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="huntingCreateVisible = false">取消</el-button>
                    <el-button :loading="huntingCreateSubmitting" @click="ValidateHuntingCreate()">确认</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 猎机套餐 -->
        <el-dialog title="猎机套餐" v-model="huntingCloudVisible" width="1300px" center>
            <div v-loading="huntingCloudLoading">
                <div style="margin-bottom:10px">
                    <span>设备：{{ huntingCloudDevice.uuid }}</span>
                </div>
                <el-table border v-bind:data="huntingCloudList" size="small" max-height="460">
                    <el-table-column label="云存记录ID" width="100">
                        <template v-slot="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="订单id" min-width="200" show-overflow-tooltip>
                        <template v-slot="scope">
                            <span>{{ scope.row.order_id }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="套餐名称" width="140" show-overflow-tooltip>
                        <template v-slot="scope">
                            <span>{{ scope.row.product_name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="套餐类型" width="110">
                        <template v-slot="scope">
                            <span>{{ huntingPackageTypeText(scope.row.package_type) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="套餐开始时间" width="160">
                        <template v-slot="scope">
                            <span>{{ changeTime(scope.row.start_time) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="套餐结束时间" width="160">
                        <template v-slot="scope">
                            <span>{{ changeTime(scope.row.end_time) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="云存储时间(天)" width="120">
                        <template v-slot="scope">
                            <span>{{ scope.row.file_time }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="金额" width="110">
                        <template v-slot="scope">
                            <span>{{ scope.row.amount ? scope.row.amount + ' ' + (scope.row.currency || '') : '--'
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="90">
                        <template v-slot="scope">
                            <span style="color:green" v-if="scope.row.status == 1">生效中</span>
                            <span v-else>已失效</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否已关闭" width="100">
                        <template v-slot="scope">
                            <span style="color:red" v-if="scope.row.is_delete == 1">已关闭</span>
                            <span v-else>正常</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="140">
                        <template v-slot="scope">
                            <el-button size="mini" type="info" v-if="canShutdownHuntingCloud(scope.row)"
                                @click="OpenHuntingShutdown(scope.row)">关闭猎机套餐</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="huntingCloudVisible = false">取消</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="关闭猎机套餐" v-model="huntingCloseVisible" width="300px" center>
            <div class="close_cloud">
                <select v-model="huntingCloseExitOrder" class="close_cloud_select" style="width:160px">
                    <option :value="0">不关闭关联4G</option>
                    <option :value="1">同时关闭关联4G</option>
                </select>
                <div class="dialog-footer">
                    <el-button :loading="huntingCloseSubmitting" @click="ConfirmHuntingShutdown()">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="开通用户套餐" v-model="userPackageOpenVisible" width="30%" center>
            <el-form label-width="90px" ref="userPackageOpenFormRef" :model="userPackageOpenForm"
                :rules="userPackageOpenRules">
                <el-form-item label="用户UID" prop="uid">
                    <el-input disabled v-model="userPackageOpenForm.uid"></el-input>
                </el-form-item>
                <el-form-item label="套餐" prop="product_id">
                    <el-select v-model="userPackageOpenForm.product_id" filterable>
                        <el-option v-for="item in packList" :key="item.SetMeal.code" :label="item.SetMeal.name"
                            v-show="item.SetMeal.status !== 3" :value="item.SetMeal.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="套餐时长" prop="cycle">
                    <el-input-number v-model="userPackageOpenForm.cycle" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="终端编号" prop="app_id">
                    <el-select v-model="userPackageOpenForm.app_id">
                        <el-option v-for="item in brandlist" :key="item.code" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="userPackageOpenVisible = false">取消</el-button>
                    <el-button @click="ValidateUserPackageOpen()">确认</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="套餐设备" v-model="userPackageDeviceVisible" width="1000px" center>
            <el-table border v-bind:data="userPackageDeviceList">
                <el-table-column label="设备UUID" show-overflow-tooltip>
                    <template v-slot="scope">
                        <span>{{ getUserPackageDeviceUuid(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称">
                    <template v-slot="scope">
                        <span>{{ (scope.row.device && scope.row.device.name) || scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备型号">
                    <template v-slot="scope">
                        <span>{{ (scope.row.device && (scope.row.device.model_code || scope.row.device.model)) || scope.row.model_code || scope.row.model }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="绑定状态" width="100">
                    <template v-slot="scope">
                        <span>{{ getUserPackageBindStatusText((scope.row.ab_subscribe_uuid && scope.row.ab_subscribe_uuid.status)) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template v-slot="scope">
                        <el-button size="mini" type="danger" @click="DeleteUserPackageDevice(scope.row)">解绑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="userPackageDeviceVisible = false">关闭</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="添加套餐设备" v-model="userPackageDeviceAddVisible" width="30%" center>
            <el-form label-width="90px" ref="userPackageDeviceFormRef" :model="userPackageDeviceForm"
                :rules="userPackageDeviceRules">
                <el-form-item label="设备UUID" prop="uuid">
                    <el-select v-model="userPackageDeviceForm.uuid" placeholder="请选择设备" filterable style="width:100%">
                        <el-option v-for="item in boundDeviceList" :key="item.uuid" :label="item.name ? (item.uuid + ' - ' + item.name) : item.uuid"
                            :value="item.uuid"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="userPackageDeviceAddVisible = false">取消</el-button>
                    <el-button @click="ValidateUserPackageDeviceAdd()">确认</el-button>
                </span>
            </template>
        </el-dialog>

        <!----------------------------分割线------------------------------------- -->
        <el-dialog title="设备的推送token" v-model="tokenFormVisible" width="600px">
            <el-form :model="tokenform" ref="tokenform">
                <el-form-item label="设备的推送token" label-width="120px">
                    <el-input type="textarea" disabled :rows="3" v-model="tokenform.token"
                        autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="tokenFormVisible = false">关闭</el-button>
                </span>
            </template>
        </el-dialog>

        <el-dialog title="App日志" v-model="logFormVisible" width="1000px">
            <el-form :model="logform" :inline="true" class="demo-form-inline" :rules="logformrules" ref="logform">
                <!-- <el-form-item label="品牌" prop="brand" label-width="60px">
          <el-select v-model="logform.brand" clearable>
            <el-option
              v-for="item in brandlist"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item> -->
                <el-form-item label="日期" prop="date" label-width="60px">
                    <el-date-picker v-model="logform.date" type="date" placeholder="Pick a Date" @change="GetLog">
                    </el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="" prop="" label-width="60px">
          <el-button type="primary" size="mini" @click="LogValidate(GetLog)">查询</el-button>
        </el-form-item> -->
            </el-form>
            <el-table border v-bind:data="logList">
                <el-table-column label="key">
                    <template v-slot="scope">
                        <span>{{ scope.row.key }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                    <template v-slot="scope">
                        <el-button type="info" size="mini" @click="DownLog(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-button type="text" :disabled="logList.length < logform.rows" @click="NextPageLog"
                    size="mini">下一页</el-button>
            </div>
        </el-dialog>

        <el-dialog title="调整用户状态" v-model="statusFormVisible" width="600px">
            <el-form :model="statusform" :rules="statusrules" ref="statusform">
                <el-form-item label="配置类型" prop="change_type" label-width="120px">
                    <el-select v-model="statusform.change_type">
                        <el-option label="关闭双重认证" value="FactorAuth"></el-option>
                        <el-option label="配置debug用户" value="Debug"></el-option>
                        <el-option label="配置测试用户" value="Test"></el-option>
                        <el-option label="配置开发者" value="Developer"></el-option>
                        <el-option label="推送配置" value="ActivePush"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="配置值" v-if="statusform.change_type !== 'FactorAuth'" prop="value"
                    label-width="120px">
                    <el-select v-model="statusform.value" :disabled="statusform.change_type == 'FactorAuth'">
                        <el-option v-if="statusform.change_type == 'Test'" label="普通用户" :value="0"></el-option>
                        <el-option v-if="statusform.change_type == 'Test'" label="测试用户" :value="1"></el-option>
                        <el-option v-if="statusform.change_type == 'Debug'" label="普通用户" :value="0"></el-option>
                        <el-option v-if="statusform.change_type == 'Debug'" label="debug用户" :value="1"></el-option>
                        <el-option v-if="statusform.change_type == 'Developer'" label="普通账号" :value="0"></el-option>
                        <el-option v-if="statusform.change_type == 'Developer'" label="开发者账号" :value="1"></el-option>
                        <el-option v-if="statusform.change_type == 'ActivePush'" label="拒绝推送" :value="0"></el-option>
                        <el-option v-if="statusform.change_type == 'ActivePush'" label="接受推送" :value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="statusFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="statusValidate(statusconfirm)">提交</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 涂鸦详情 -->
        <el-dialog title="涂鸦设备详情" v-model="tuyaFormVisible" width="800px">
            <el-form :model="tuyaform" inline>
                <el-form-item label="产品型号" label-width="120px">
                    <el-input disabled v-model="tuyaform.model" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="产品id" label-width="120px">
                    <el-input disabled v-model="tuyaform.product_id" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" label-width="120px">
                    <el-input disabled v-model="tuyaform.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="所属用户" label-width="120px">
                    <el-input disabled v-model="tuyaform.tuyauid" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备UUID" label-width="120px">
                    <el-input disabled v-model="tuyaform.uuid" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="设备IP" label-width="120px">
                    <el-input disabled v-model="tuyaform.ip" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="在线状态" label-width="120px">
                    <el-input disabled v-model="tuyaform.online" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="初次配网时间" label-width="120px">
                    <el-input disabled v-model="tuyaform.create_time" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="上次配网时间" label-width="120px">
                    <el-input disabled v-model="tuyaform.active_time" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="状态更新时间" label-width="120px">
                    <el-input disabled v-model="tuyaform.update_time" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="所在时区" label-width="120px">
                    <el-input disabled v-model="tuyaform.time_zone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="产品类别" label-width="120px">
                    <el-input disabled v-model="tuyaform.category" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密钥" label-width="120px">
                    <el-input disabled v-model="tuyaform.local_key" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="tuyaFormVisible = false">取 消</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 涂鸦用户详情信息 -->
        <el-dialog v-model="userInfoVisible" title="用户详情" width="400px">
            <p style="padding: 8px 0px">
                <b>用户账号：</b><span>{{ userInfo?.account }}</span>
            </p>
            <p style="padding: 8px 0px">
                <b>区域：</b><span>{{ userInfo?.region }}</span>
            </p>
            <p style="padding: 8px 0px">
                <b>终端：</b><span>{{ userInfo?.schema }}</span>
            </p>
            <p style="padding: 8px 0px">
                <b>涂鸦uid：</b><span>{{ userInfo?.tuya_uid }}</span>
            </p>
            <p style="padding: 8px 0px">
                <b>用户标识：</b><span>{{ userInfo?.uid }}</span>
            </p>
        </el-dialog>
        <!-- 涂鸦日志 -->
        <el-dialog title="涂鸦设备日志" v-model="tuyaLogVisible" width="1000px">
            <el-form :model="tuyalogform" :inline="true" class="demo-form-inline" :rules="tuyalogrules"
                ref="tuyalogform">
                <el-form-item>
                    <el-select v-model="tuyalogform.type" @change="GetTuyaLogList" placeholder="日志查询支持的类型">
                        <el-option label="上线" :value="1"></el-option>
                        <el-option label="下线" :value="2"></el-option>
                        <el-option label="设备激活" :value="3"></el-option>
                        <el-option label="设备重置" :value="4"></el-option>
                        <el-option label="指令下发" :value="5"></el-option>
                        <el-option label="固件升级" :value="6"></el-option>
                        <el-option label="数据点上报" :value="7"></el-option>
                        <el-option label="设备信号量" :value="8"></el-option>
                        <el-option label="设备重启" :value="9"></el-option>
                        <el-option label="定时信息" :value="10"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="tuyalogform.codes" @change="GetTuyaLogList" placeholder="设备支持的功能点"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="tuyalogform.start_row_key" @change="GetTuyaLogList"
                        placeholder="查询Hbase的行键"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="datevalue" @change="GetTuyaLogList" type="daterange" range-separator="至"
                        start-placeholder="起始时间" end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-input-number v-model="tuyalogform.size" :min="1" @change="GetTuyaLogList" placeholder="查询的行数" />
                </el-form-item>
            </el-form>
            <el-table border v-bind:data="tuyalogList">
                <el-table-column label="事件的类型">
                    <template v-slot="scope">
                        <span>{{ ChangeStatus(scope.row.event_id) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template v-slot="scope">
                        <span>{{
                            scope.row.status == 1 ? '有效' : '未知'
                            }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="tuyaLogVisible = false">取 消</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="设备影子" v-model="deviceShadowVisible" width="1400px" center>
            <json-editor-vue class="editor" v-model="userDeviceShadow" />
        </el-dialog>
        <!-- 设备影子弹窗 -->
        <DeviceShadowDialog v-model="deviceShadowDialog.visible" :shadow-data="deviceShadowDialog.data"
            :loading="deviceShadowDialog.loading" :device-info="deviceShadowDialog.deviceInfo"
            @close="closeDeviceShadowDialog" destroy-on-close />
    </div>
</template>

<script type="text/ecmascript-6">
import { ElMessage, ElMessageBox } from 'element-plus'
import util from '../../../util/util'
import api from '../../../axios/pack'
import {
    logEventStatus
} from '../../../assets/js/dictionary'
import JsonEditorVue from 'json-editor-vue3'
import DeviceShadowDialog from '../../../components/device/DeviceShadowDialog.vue'

export default {
    name: '',
    mixins: [],
    components: {
        JsonEditorVue,
        DeviceShadowDialog
    },
    props: {},
    data() {
        return {
            util: util,
            userInfoVisible: false,
            userInfo: {},
            pushType: [{
                value: '极光',
                key: 1
            },
            {
                value: 'FCM',
                key: 2
            },
            {
                value: 'APNS',
                key: 3
            },
            {
                value: '个推',
                key: 4
            },
            {
                value: '友盟',
                key: 5
            },
            ],
            accountType: {
                0: '邮箱',
            },
            uid: '',
            region: '',
            schema: '',
            freeTrialSubmitting: false,
            form: {
                account: '',
                country: '',
                create_time: '',
                nickname: '',
                region: '',
                schema: '',
                tuya_uid: '',
                uid: '',
                zone: '',
            },
            alexa: 0,
            google_home: 0,
            userform: {
                account: '',
                account_type: '',
                avatar: '',
                delete_time: '',
                nickname: '',
                register_country: '',
                register_ip: '',
                register_time: '',
                schema: '',
                tuya_region: '',
                uid: '',
                update_time: '',
            },
            loginlist: [],
            trustDevlist: [],
            list: [],
            search: {
                page: 1,
                limit: 10,
            },
            total: 0,
            predisabled: false,
            nextdisabled: false,
            statusFormVisible: false,
            statusform: {
                change_type: '',
                uid: '',
                value: '',
                schema: '',
            },
            statusrules: {
                change_type: [{
                    required: true,
                    message: '请选择配置类型',
                    trigger: 'blur'
                }],
                value: [{
                    required: true,
                    message: '请选择配置值',
                    trigger: 'blur'
                }],
            },
            tokenFormVisible: false,
            tokenform: {
                token: ''
            },
            tuyalist: [],
            logform: {
                date: '',
                brand: '',
                appid: '',
                lastKey: '',
                rows: 10,
                prefix: ''
            },
            logFormVisible: false,
            isShowCloseCloudDialog: false,
            isShowMigrateCloudDialog: false,
            closeCloudId: '',
            // closeCloudUid:'',
            // closeCloudUuid:'',
            isReturnMoney: 2,
            migrateCloudId: '',
            migrateUuid: '',
            logformrules: {
                date: [{
                    required: true,
                    message: '请选择日期',
                    trigger: 'blur'
                }]
            },
            brandlist: [],
            logList: [],
            tuyaFormVisible: false,
            tuyaform: {},
            // 涂鸦日志
            datevalue: '',
            tuyaLogVisible: false,
            tuyalogform: {
                device_id: '',
                tuya_region: '',
                type: 1,
                codes: '',
                start_row_key: '',
                start_time: '',
                end_time: '',
                size: 10,
            },
            tuyalogrules: {},
            tuyalogList: [],
            // 绑定设备
            bindlist: [],
            packFormVisible: false,
            creatcloudform: {
                product_id: '',
                uid: '',
                uuid: '',
                region: '',
                cycle: '',
                app_id: ''
            },
            rules: {
                product_id: [{
                    required: true,
                    message: '请选择套餐',
                    trigger: 'blur'
                }],
                cycle: [{
                    required: true,
                    message: '请输入套餐时长',
                    trigger: 'blur'
                }],
                app_id: [{
                    required: true,
                    message: '请选择终端编号',
                    trigger: 'change'
                }],
            },
            packList: [],
            cloudFormVisible: false,
            cloudList: [{}],
            userPackageSearchAppId: '',
            userPackageList: [],
            userPackageSearch: {
                page: 1,
                limit: 10
            },
            userPackageTotal: 0,
            userPackageOpenVisible: false,
            userPackageOpenForm: {
                uid: '',
                product_id: '',
                app_id: '',
                cycle: 1
            },
            userPackageOpenRules: {
                uid: [{
                    required: true,
                    message: '请输入用户UID',
                    trigger: 'blur'
                }],
                product_id: [{
                    required: true,
                    message: '请选择套餐',
                    trigger: 'change'
                }],
                cycle: [{
                    required: true,
                    message: '请输入套餐时长',
                    trigger: 'blur'
                }],
                app_id: [{
                    required: true,
                    message: '请选择终端编号',
                    trigger: 'change'
                }]
            },
            userPackageDeviceVisible: false,
            userPackageDeviceAddVisible: false,
            userPackageDeviceList: [],
            userPackageCurrentRow: {},
            userPackageDeviceForm: {
                uuid: ''
            },
            userPackageDeviceRules: {
                uuid: [{
                    required: true,
                    message: '请输入设备UUID',
                    trigger: 'blur'
                }]
            },
            simdataList: [],
            simdataShow: false,
            simdataOpenVisible: false,
            simdataOpenForm: {
                uuid: '',
                uid: '',
                schema: '',
                package_code: ''
            },
            simdataOpenRules: {
                uuid: [{
                    required: true,
                    message: '请输入UUID',
                    trigger: 'blur'
                }],
                uid: [{
                    required: true,
                    message: '请输入UID',
                    trigger: 'blur'
                }],
                schema: [{
                    required: true,
                    message: '请选择品牌appid',
                    trigger: 'change'
                }],
                package_code: [{
                    required: true,
                    message: '请选择套餐',
                    trigger: 'change'
                }]
            },
            simdataPackList: [],
            simdataCloseVisible: false,
            simdataReturnMoney: 2,
            simdataCloseOrderId: '',
            simdataCloseSimId: '',
            simdataCurrentUid: '',
            // 猎机套餐
            huntingCreateVisible: false,
            huntingCreateLoading: false,
            huntingCreateSubmitting: false,
            huntingCreateForm: {
                uuid: '',
                uid: '',
                model_code: '',
                app_id: '',
                package_code: '',
                description: ''
            },
            huntingCreateRules: {
                uuid: [{
                    required: true,
                    message: '请输入UUID',
                    trigger: 'blur'
                }],
                uid: [{
                    required: true,
                    message: '请输入UID',
                    trigger: 'blur'
                }],
                app_id: [{
                    required: true,
                    message: '请选择终端编号',
                    trigger: 'change'
                }],
                package_code: [{
                    required: true,
                    message: '请选择套餐',
                    trigger: 'change'
                }]
            },
            huntingPackList: [],
            huntingCloudVisible: false,
            huntingCloudLoading: false,
            huntingCloudDevice: {},
            huntingCloudList: [],
            huntingCloseVisible: false,
            huntingCloseSubmitting: false,
            huntingCloseExitOrder: 0,
            huntingCloseCloudInfoId: 0,
            currencyList: [],
            // s3key分析
            formVisibl: false,
            analyseform: {
                appid_equal: '',
                file_brand: '',
                brand_equal: '',
                version: '',
                region: '',
                file_key: '',
                key_appid_right: '',
                key_brand_right: '',
            },
            s3FormVisible: false,
            s3form: {
                date: '',
                appid: '3dab98eee85b7ae8',
                uid: '',
                uuid: '',
                file_time: ''
            },
            s3formrules: {},
            s3KeyList: [],
            warrantyOrderList: [],
            amazonCrrrentRow: {},
            amazonRemark: '',
            amazonRemarkDialog: false,
            userDeviceShadow: {},
            deviceShadowVisible: false,
            deviceShadowDialog: {
                visible: false,
                loading: false,
                data: null,
                deviceInfo: {}
            },
            levelList: []
        }
    },
    computed: {
        alexaText() {
            return this.alexa == 1 ? '是' : '否'
        },
        googleHomeText() {
            return this.google_home == 1 ? '是' : '否'
        },
        boundDeviceList() {
            return this.bindlist.filter(item => item.status == 1)
        },
    },
    watch: {},
    methods: {
        async setFreeTrialUser() {
            if (this.freeTrialSubmitting || !this.uid) return
            this.freeTrialSubmitting = true
            try {
                await ElMessageBox.confirm(
                    `确定将用户 ${this.uid} 设置为14天免费试用活动用户吗？活动资格标记有效期为24小时，重复设置会刷新有效期；此操作不会直接开通套餐。`,
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                )
                const res = await this.api.RegionSetFreeTrialUser({
                    uid: String(this.uid)
                })
                if (res.data.code == 200) {
                    this.$message.success('已设置为14天免费试用活动用户，资格标记有效期24小时')
                    return
                }
                this.$message.error('设置失败：' + res.data.msg)
            } catch (error) {
                // 取消确认无需提示，网络错误由统一请求封装提示
                if (error !== 'cancel' && error !== 'close') {
                    console.error('设置免费试用活动用户失败', error)
                }
            } finally {
                this.freeTrialSubmitting = false
            }
        },
        SyncTomeZone() {
            ElMessageBox.confirm('你确定要同步时区吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    this.api.SyncTimeZone({
                        uid: this.uid,
                        schema: this.schema
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('同步时区成功')
                            return
                        }
                        this.$message.error('调用失败:' + res.data.msg)
                    })
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消同步时区')
                })
        },
        onJsonChange(value) {
            console.log('value:', value)
        },
        GetWarrantyOrderList() {
            this.api.WarrantyOrderList({
                page: 1,
                limit: 1000,
                email: '',
                uid: this.uid,
                order_no: '',
                start_time: '',
                end_time: ''
            }).then(res => {
                if (res.data.code == 200) {
                    this.warrantyOrderList = res.data.data.list
                    this.total = res.data.data.page_info.total
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        openAmazonRemark(row) {
            this.amazonCrrrentRow = row
            this.amazonRemark = row.remark
            this.amazonRemarkDialog = true
        },
        updateAmazonRemark() {
            this.api.WarrantyOrderUpdate({
                id: this.amazonCrrrentRow.id,
                remark: this.amazonRemark
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('修改成功')
                    this.amazonRemarkDialog = false
                    this.GetWarrantyOrderList()
                    return
                }
                this.$message.error('调用失败:' + res.data.msg)
            })
        },
        // 绑定设备
        GetBindDevice() {
            this.api.UserDeviceList({
                page: 1,
                limit: 10,
                uid: this.uid,
                region: this.region,
            }).then(res => {
                if (res.data.code == 200) {
                    this.bindlist = res.data.data
                    this.GetWarrantyOrderList()
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        isRequestSuccess(res) {
            return res && res.data && (res.data.code == 200 || res.data.code == 1000)
        },
        getResponseList(data) {
            if (Array.isArray(data)) return data
            if (data && Array.isArray(data.list)) return data.list
            if (data && Array.isArray(data.data)) return data.data
            return []
        },
        getUserPackageSubscribeId(item) {
            return item.subscribe_id || (item.ab_subscribe && item.ab_subscribe.subscribe_id) || ''
        },
        getUserPackageOrderId(item) {
            return item.order_id || (item.order && item.order.order_id) || ''
        },
        getUserPackageAppId(item) {
            return (item && (item.app_id || item.schema)) || this.userPackageSearchAppId || this.schema || this.userform.schema
        },
        getUserPackageName(item) {
            return item.package_name || item.product_name || item.set_meal_name || (item.SetMeal && item.SetMeal.name) || ''
        },
        getUserPackageStatusText(status) {
            const statusMap = {
                0: '未订阅',
                1: '已订阅',
                2: '已停止',
                3: '已删除'
            }
            return statusMap[status] || '未知'
        },
        getUserPackageBindStatusText(status) {
            const statusMap = {
                1: '已绑定',
                2: '已解绑'
            }
            return statusMap[status] || '未知'
        },
        getUserPackageDeviceUuid(item) {
            return item.uuid || (item.ab_subscribe_uuid && item.ab_subscribe_uuid.uuid) || (item.device && item.device.uuid) || ''
        },
        formatPackageTime(time) {
            if (!time) return '--:--:--'
            const value = Number(time)
            if (Number.isNaN(value)) return time
            return util.dateFormat(value > 9999999999 ? Math.floor(value / 1000) : value)
        },
        GetPackageList() {
            api.PackageList({
                page: 1,
                limit: 1000,
                kname: '',
                code: '',
                is_event: -1,
            }).then(res => {
                if (this.isRequestSuccess(res)) {
                    this.packList = this.getResponseList(res.data.data)
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        GetPackageLevelList() {
            api.PackageLevelList({}).then(res => {
                if (res.data.code == 200) {
                    this.levelList = res.data.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        getLevelName(level) {
            const item = this.levelList.find(v => v.set_meal_level === level)
            return item ? item.level_name : level
        },
        GetUserPackageList() {
            const appId = this.userform.schema
            if (!this.uid || !appId) {
                this.userPackageList = []
                this.userPackageTotal = 0
                return
            }
            this.api.UserPackageCloudList({
                uid: this.uid,
                app_id: appId,
                page: this.userPackageSearch.page,
                limit: this.userPackageSearch.limit
            }).then(res => {
                if (this.isRequestSuccess(res)) {
                    this.userPackageList = res.data.data.data || []
                    this.userPackageTotal = (res.data.data.page_info && res.data.data.page_info.total) || 0
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        handleUserPackagePageChange(page) {
            this.userPackageSearch.page = page
            this.GetUserPackageList()
        },
        OpenUserPackage() {
            this.userPackageOpenForm = {
                uid: this.uid,
                product_id: '',
                app_id: this.userform.schema,
                cycle: 1
            }
            this.userPackageOpenVisible = true
            this.GetPackageList()
        },
        ValidateUserPackageOpen() {
            this.$refs['userPackageOpenFormRef'].validate(res => {
                if (res) {
                    this.ConfirmUserPackageOpen()
                }
            })
        },
        ConfirmUserPackageOpen() {
            this.api.UserPackageCreate(this.userPackageOpenForm).then(res => {
                if (this.isRequestSuccess(res)) {
                    this.$message.success('套餐开通成功')
                    this.userPackageOpenVisible = false
                    this.userPackageSearchAppId = this.userPackageOpenForm.app_id
                    this.GetUserPackageList()
                    return
                }
                this.$message.error('套餐开通失败' + res.data.msg)
            })
        },
        OpenUserPackageDeviceList(item) {
            const subscribeId = this.getUserPackageSubscribeId(item)
            const appId = this.getUserPackageAppId(item)
            if (!subscribeId || !appId) {
                this.$message.error('订阅编号或终端编号为空')
                return
            }
            this.userPackageCurrentRow = item
            this.api.UserPackageUuidList({
                uid: item.uid || this.uid,
                subscribe_id: subscribeId,
                app_id: appId
            }).then(res => {
                if (this.isRequestSuccess(res)) {
                    this.userPackageDeviceList = this.getResponseList(res.data.data)
                    this.userPackageDeviceVisible = true
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        OpenUserPackageDeviceAdd(item) {
            this.userPackageCurrentRow = item
            this.userPackageDeviceForm = {
                uuid: ''
            }
            this.userPackageDeviceAddVisible = true
        },
        ValidateUserPackageDeviceAdd() {
            this.$refs['userPackageDeviceFormRef'].validate(res => {
                if (res) {
                    this.ConfirmUserPackageDeviceAdd()
                }
            })
        },
        ConfirmUserPackageDeviceAdd() {
            const subscribeId = this.getUserPackageSubscribeId(this.userPackageCurrentRow)
            const appId = this.getUserPackageAppId(this.userPackageCurrentRow)
            if (!subscribeId || !appId) {
                this.$message.error('订阅编号或终端编号为空')
                return
            }
            this.api.UserPackageUuidAdd({
                uid: this.userPackageCurrentRow.uid || this.uid,
                subscribe_id: subscribeId,
                app_id: appId,
                uuid: this.userPackageDeviceForm.uuid
            }).then(res => {
                if (this.isRequestSuccess(res)) {
                    this.$message.success('设备添加成功')
                    this.userPackageDeviceAddVisible = false
                    this.OpenUserPackageDeviceList(this.userPackageCurrentRow)
                    return
                }
                this.$message.error('设备添加失败' + res.data.msg)
            })
        },
        DeleteUserPackageDevice(item) {
            const uuid = this.getUserPackageDeviceUuid(item)
            const subscribeId = this.getUserPackageSubscribeId(this.userPackageCurrentRow)
            const appId = this.getUserPackageAppId(this.userPackageCurrentRow)
            if (!uuid || !subscribeId || !appId) {
                this.$message.error('设备UUID、订阅编号或终端编号为空')
                return
            }
            this.$confirm('你确定要解绑该套餐设备吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.UserPackageUuidDelete({
                    uid: this.userPackageCurrentRow.uid || this.uid,
                    subscribe_id: subscribeId,
                    app_id: appId,
                    uuid: uuid
                }).then(res => {
                    if (this.isRequestSuccess(res)) {
                        this.$message.success('设备解绑成功')
                        this.OpenUserPackageDeviceList(this.userPackageCurrentRow)
                        return
                    }
                    this.$message.error('设备解绑失败' + res.data.msg)
                })
            }).catch(() => { })
        },
        CancelUserPackageRenew(item) {
            const subscribeId = this.getUserPackageSubscribeId(item)
            const appId = this.getUserPackageAppId(item)
            if (!subscribeId || !appId) {
                this.$message.error('订阅编号或终端编号为空')
                return
            }
            this.$confirm('确定取消当前套餐续订？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.UserPackageUnsubscribe({
                    uid: item.uid || this.uid,
                    subscribe_id: subscribeId,
                    app_id: appId
                }).then(res => {
                    if (this.isRequestSuccess(res)) {
                        this.$message.success('套餐续订取消成功')
                        this.GetUserPackageList()
                        return
                    }
                    this.$message.error('套餐续订取消失败' + res.data.msg)
                })
            }).catch(() => { })
        },
        ShutdownUserPackage(item) {
            const subscribeId = this.getUserPackageSubscribeId(item)
            const orderId = this.getUserPackageOrderId(item)
            const appId = this.getUserPackageAppId(item)
            if (!subscribeId || !orderId || !appId) {
                this.$message.error('订阅编号、订单编号或终端编号为空')
                return
            }
            this.$confirm('确定关闭当前套餐？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.UserPackageShutdown({
                    uid: item.uid || this.uid,
                    subscribe_id: subscribeId,
                    app_id: appId,
                    order_id: orderId
                }).then(res => {
                    if (this.isRequestSuccess(res)) {
                        this.$message.success('套餐关闭成功')
                        this.GetUserPackageList()
                        return
                    }
                    this.$message.error('套餐关闭失败' + res.data.msg)
                })
            }).catch(() => { })
        },
        unbinding(item) {
            this.$confirm('你确定要取消绑定吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.api.DeleteBind({
                    schema: this.schema,
                    uid: item.uid,
                    uuid: item.uuid,
                    region: this.region
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('解绑成功')
                        return
                    }
                    this.$message.error('解绑失败' + res.data.msg)
                })
            }).catch((e) => {
                console.log(e)
                this.$message({
                    type: 'info',
                    message: '已取消解绑'
                })
            })
        },
        CreateCloud(item) {
            this.packFormVisible = true
            this.creatcloudform.uid = item.uid
            this.creatcloudform.uuid = item.uuid
            this.creatcloudform.region = this.search.region
            this.GetPackageList()
        },
        GetCloudInfo(item) {
            this.s3form.uid = item.uid
            this.api.OnlineCloudInfo({
                uid: item.uid,
                uuid: item.uuid,
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.cloudList = res.data.data
                    this.cloudFormVisible = true
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        GetSimdataList(item) {
            this.api.SimdataDataList({
                page: 1,
                limit: 500,
                uid: item.uid,
                uuid: item.uuid
            }).then(res => {
                if (res.data.code == 200) {
                    this.simdataList = res.data.data.list || res.data.data.data || []
                    this.simdataShow = true
                    this.simdataCurrentUid = item.uid || ''
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        cancelSimdataRenew(item) {
            this.$confirm('确定取消当前设备订阅的4G套餐？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (!item.subscribe_id) {
                    this.$message.error('订阅编号为空')
                    return
                }
                this.api.SimdataSubscribeUnsubscribe({
                    subscribe_id: item.subscribe_id
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('4G套餐续订取消成功')
                        if (this.simdataCurrentUid) {
                            this.GetSimdataList({ uid: this.simdataCurrentUid })
                        }
                        return
                    }
                    this.$message.error(res.data.msg)
                })
            }).catch(() => { })
        },
        openSimdataClose(item) {
            this.simdataCloseOrderId = item.order_id || ''
            this.simdataCloseSimId = item.sim_id || ''
            this.simdataCloseVisible = true
        },
        confirmSimdataClose() {
            if (!this.simdataCloseOrderId || !this.simdataCloseSimId) {
                this.$message.error('订单号或SIM ID为空')
                return
            }
            this.api.SimdataDataShutdown({
                order_id: this.simdataCloseOrderId,
                sim_id: this.simdataCloseSimId,
                exit_order: this.simdataReturnMoney
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('4G套餐关闭成功')
                    this.simdataCloseVisible = false
                    if (this.simdataCurrentUid) {
                        this.GetSimdataList({ uid: this.simdataCurrentUid })
                    }
                    return
                }
                this.$message.error(res.data.msg)
            })
        },
        OpenSimdata(item) {
            this.simdataOpenForm = {
                uuid: item.uuid || '',
                uid: item.uid || '',
                schema: item.schema || '',
                package_code: ''
            }
            this.simdataOpenVisible = true
            this.getSimdataPackList()
        },
        getSimdataPackList() {
            api.FourGPackageList({
                page: 1,
                limit: 1000
            }).then(res => {
                if (res.data.code == 200) {
                    this.simdataPackList = res.data.data.data || []
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        ValidateSimdataOpen() {
            this.$refs['simdataOpenFormRef'].validate(res => {
                if (res) {
                    this.ConfirmSimdataOpen()
                }
            })
        },
        ConfirmSimdataOpen() {
            this.api.SimdataDataOpen(this.simdataOpenForm).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('开通成功')
                    this.simdataOpenVisible = false
                    return
                }
                this.$message.error('开通失败' + res.data.msg)
            })
        },
        // ---------------- 猎机套餐 ----------------
        // 目前约定：型号以 WT10_ 开头的设备为猎机（打猎相机）
        isHuntingDevice(target) {
            if (!target) return false
            const model = typeof target === 'object' ? (target.model_code || target.model) : target
            if (typeof model !== 'string') return false
            return model.toUpperCase().startsWith('WT10_')
        },
        huntingPackageTypeText(type) {
            return type == 1 ? '通信+云存储' : type == 2 ? '纯云存储' : '--'
        },
        huntingPackageLabel(item) {
            const parts = [item.name, item.time + ' ' + item.time_unit, this.huntingPackageTypeText(item.package_type)]
            if (item.is_trial == 1) parts.push('试用' + item.trial_days + '天')
            if (item.status === 0) parts.push('测试')
            return parts.join(' / ')
        },
        getHuntingAppId(item) {
            return (item && item.schema) || this.schema || this.userform.schema || ''
        },
        OpenHuntingCreate(item) {
            const modelCode = item.model_code || item.model || ''
            this.huntingCreateForm = {
                uuid: item.uuid || '',
                uid: item.uid || this.uid || '',
                model_code: modelCode,
                app_id: this.getHuntingAppId(item),
                package_code: '',
                description: ''
            }
            this.huntingPackList = []
            this.huntingCreateVisible = true
            this.GetHuntingPackList(modelCode)
        },
        // 只列出与该设备型号关联、且处于上架/测试状态的套餐
        GetHuntingPackList(modelCode) {
            this.huntingCreateLoading = true
            api.HuntingPackageList({
                page: 1,
                limit: 200,
                product_model_code: modelCode,
                model_action: 1,
                status: JSON.stringify([0, 1])
            }).then(res => {
                if (res.data.code == 200) {
                    this.huntingPackList = this.getResponseList(res.data.data)
                    return
                }
                this.$message.error('获取套餐失败' + res.data.msg)
            }).finally(() => {
                this.huntingCreateLoading = false
            })
        },
        ValidateHuntingCreate() {
            this.$refs['huntingCreateFormRef'].validate(res => {
                if (res) {
                    this.ConfirmHuntingCreate()
                }
            })
        },
        ConfirmHuntingCreate() {
            const form = this.huntingCreateForm
            const selected = this.huntingPackList.find(v => v.code === form.package_code)
            const tip = '确定为设备 ' + form.uuid + ' 开通猎机套餐「' + (selected ? selected.name : form.package_code) + '」？'
            this.$confirm(tip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.huntingCreateSubmitting = true
                api.HuntingCloudCreate({
                    region: this.region,
                    uid: form.uid,
                    uuid: form.uuid,
                    package_code: form.package_code,
                    app_id: form.app_id,
                    description: form.description || ''
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('猎机套餐开通成功!')
                        this.huntingCreateVisible = false
                        return
                    }
                    this.$message.error('猎机套餐开通失败' + res.data.msg)
                }).finally(() => {
                    this.huntingCreateSubmitting = false
                })
            }).catch(() => { })
        },
        // 查看当前开通的猎机套餐
        GetHuntingCloudInfo(item) {
            this.huntingCloudDevice = {
                uuid: item.uuid || '',
                uid: item.uid || this.uid || '',
                app_id: this.getHuntingAppId(item)
            }
            this.huntingCloudList = []
            this.huntingCloudVisible = true
            this.GetHuntingCloudList()
        },
        GetHuntingCloudList() {
            this.huntingCloudLoading = true
            api.HuntingCloudList({
                region: this.region,
                uid: this.huntingCloudDevice.uid,
                uuid: this.huntingCloudDevice.uuid,
                app_id: this.huntingCloudDevice.app_id
            }).then(res => {
                if (res.data.code == 200) {
                    this.huntingCloudList = this.getResponseList(res.data.data)
                    return
                }
                this.$message.error('获取套餐记录失败' + res.data.msg)
            }).finally(() => {
                this.huntingCloudLoading = false
            })
        },
        // 可关闭：未关闭且未到期
        canShutdownHuntingCloud(item) {
            return item.is_delete == 0 && item.end_time > Math.floor(Date.now() / 1000)
        },
        OpenHuntingShutdown(item) {
            this.huntingCloseCloudInfoId = item.id
            this.huntingCloseExitOrder = 0
            this.huntingCloseVisible = true
        },
        ConfirmHuntingShutdown() {
            const exitOrder = Number(this.huntingCloseExitOrder) === 1 ? 1 : 0
            this.huntingCloseSubmitting = true
            api.HuntingCloudShutdown({
                region: this.region,
                cloud_info_id: this.huntingCloseCloudInfoId,
                exit_order: exitOrder
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('猎机套餐关闭成功!')
                    this.huntingCloseVisible = false
                    this.GetHuntingCloudList()
                    return
                }
                this.$message.error('猎机套餐关闭失败' + res.data.msg)
            }).finally(() => {
                this.huntingCloseSubmitting = false
            })
        },
        // 获取设备影子
        UserDeviceShadow(row) {
            this.api.UserDeviceShadow({
                uid: row.uid,
                uuid: row.uuid,
            }).then(res => {
                if (res.data.code == 200) {
                    // this.userDeviceShadow = res.data.data
                    // this.deviceShadowVisible = true
                    this.deviceShadowDialog.deviceInfo = {
                        uuid: row.uuid
                    }
                    this.deviceShadowDialog.data = {
                        shadow: res.data.data,
                        tsl_attribute: this.tslAttribute
                    }
                    this.deviceShadowDialog.visible = true
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        getSimdataStatusText(status) {
            const statusMap = {
                0: '未激活',
                1: '已激活',
                2: '已停止',
                3: '已删除'
            }
            return statusMap[status] || '未知'
        },
        formatDataLimitKb(dataLimitKb) {
            if (dataLimitKb === null || dataLimitKb === undefined || dataLimitKb === '') return '--'
            const kb = Number(dataLimitKb)
            if (Number.isNaN(kb)) return '--'
            if (kb < 1024) return `${kb.toFixed(0)}KB`

            const mb = kb / 1024
            return mb >= 1024 ? `${(mb / 1024).toFixed(1)}GB` : `${mb.toFixed(0)}MB`
        },
        // 判断是否4G设备：优先用接口返回的 network_type（1-wifi 2-4g），
        // 接口未返回时回退到型号前缀判断
        isSimdataModel(target) {
            if (!target) return false
            if (typeof target === 'object') {
                const networkType = target.network_type
                if (networkType !== null && networkType !== undefined && networkType !== '') {
                    return Number(networkType) === 2
                }
                return this.isSimdataModel(target.model_code || target.model)
            }
            if (typeof target !== 'string') return false
            return target.startsWith('GW41_') || target.startsWith('GW40_')
        },
        S3KeyAnalyse(item) {
            this.s3form.uuid = item.uuid
            this.s3form.file_time = item.file_time
            this.s3form.appid = item.schema
            this.GetS3key()
        },
        closeCloud(item) {
            this.closeCloudId = item.id
            // this.closeCloudUid=item.uid
            // this.closeCloudUuid=item.uuid
            this.isShowCloseCloudDialog = true
        },
        migrateCloud(item) {
            this.migrateUuid = ''
            this.migrateCloudId = item.id
            this.isShowMigrateCloudDialog = true
        },
        closelCloudConfirm() {
            let data = {
                exit_order: this.isReturnMoney,
                id: this.closeCloudId
            }
            this.api.CloseCloud(data).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        "type": "success",
                        "message": "云存储关闭成功！"
                    })
                    this.isShowCloseCloudDialog = false
                    this.cloudFormVisible = false
                    // this.GetCloudInfo({uid:this.closeCloudUid, uuid:this.closeCloudUuid})
                } else {
                    this.$message({
                        "type": "error",
                        "message": res.data.msg
                    })
                }
            }).catch(err => {
                console.log('请求失败：', err)
            })
        },
        migrateCloudConfirm() {
            let data = {
                to_uuid: this.migrateUuid,
                id: this.migrateCloudId
            }
            this.api.MigrateCloud(data).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        "type": "success",
                        "message": "云存储迁移成功！"
                    })
                    this.isShowMigrateCloudDialog = false
                    this.cloudFormVisible = false
                } else {
                    this.$message({
                        "type": "error",
                        "message": res.data.msg
                    })
                }
            }).catch(err => {
                console.log('请求失败：', err)
            })
        },
        cancelCloudRenew(item) {
            this.$confirm('确定取消当前设备订阅的云存储？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    uuid: item.uuid,
                    uid: item.uid
                }
                this.api.CancelCloudRenew(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            "type": "success",
                            "message": "云存储套餐订阅取消成功！"
                        })
                    } else {
                        this.$message({
                            "type": "error",
                            "message": res.data.msg
                        })
                    }
                }).catch(err => {
                    console.log('请求失败：', err)
                })
            }).catch(() => { })
        },
        GetS3key() {
            this.s3KeyList = []
            this.form = {}
            let time = this.s3form.date ? util.dateSingle(this.s3form.date) : ''
            this.api.FileLogListAnalyse({
                rows: 10,
                prefix: 'media' + this.s3form.file_time + '/' + this.s3form.appid + '/' + this.s3form.uuid + '_' + this.s3form.uid + '/' + time,
                // region: this.search.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.s3FormVisible = true
                    this.formVisibl = true
                    this.analyseform.appid_equal = res.data.data.appid_equal
                    this.analyseform.file_brand = res.data.data.file_brand
                    this.analyseform.brand_equal = res.data.data.brand_equal
                    this.analyseform.version = res.data.data.version
                    this.analyseform.region = res.data.data.region
                    this.analyseform.file_key = res.data.data.file_key
                    this.analyseform.key_appid_right = res.data.data.key_appid_right
                    this.analyseform.key_brand_right = res.data.data.key_brand_right
                    this.s3KeyList = res.data.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        CreateConfirm() {
            this.api.OnlineCreateCloud(this.creatcloudform, {
                region: this.search.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('套餐开通成功!')
                    this.packFormVisible = false
                    return
                }
                this.$message.error('套餐开通失败' + res.data.msg)
            })
        },
        Validate: function (call) {
            this.$refs['creatcloudform'].validate(res => {
                if (res && call) {
                    call()
                }
            })
        },

        // ---------------------分割线-----------------------
        ChangeStatus(item) {
            return util.handleValueDisplay(logEventStatus, item)
        },
        TuyaLog(item) {
            this.tuyaLogVisible = true
            this.tuyalogform.device_id = item.id
            this.GetTuyaLogList()
        },
        GetTuyaLogList() {
            this.api.UserTuyaLog({
                device_id: this.tuyalogform.device_id,
                tuya_region: this.region,
                type: this.tuyalogform.type,
                codes: this.tuyalogform.codes,
                start_row_key: this.tuyalogform.start_row_key,
                start_time: this.datevalue ? Date.parse(this.datevalue[0]) / 1000 : null,
                end_time: this.datevalue ? Date.parse(this.datevalue[1]) / 1000 : null,
                size: this.tuyalogform.size,
            }).then(res => {
                this.tuyalogList = res.data.data.logs
            })
        },
        TuyaInfo(item) {
            this.tuyaFormVisible = true
            this.tuyaform = item
            this.tuyaform.create_time = this.changeTime(this.tuyaform.create_time)
            this.tuyaform.active_time = this.changeTime(this.tuyaform.active_time)
            this.tuyaform.update_time = this.changeTime(this.tuyaform.update_time)
        },
        NextPageLog() {
            this.logform.lastKey = this.logList.length ? this.logList[this.logList.length - 1].key : ''
            this.GetLog()
        },
        AppLog(item) {
            this.logform.prefix = 'applog/' + item.schema + '/' + item.uid + '/'
            console.log(this.logform.prefix)
            this.logform.appid = item.schema
            this.logFormVisible = true
        },
        LogValidate(call) {
            this.$refs['logform'].validate(res => {
                if (res && call) {
                    call()
                }
            })
        },
        GetLog() {
            this.api.FileLogList({
                brand: this.logform.brand,
                appid: this.logform.appid,
                lastKey: this.logform.lastKey,
                rows: this.logform.rows,
                prefix: this.logform.prefix + util.dateSingle(this.logform.date),
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.logList = res.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        DownLog(item) {
            this.api.FileLogDown({
                brand: '',
                appid: this.logform.appid,
                is_cdn: '',
                key: item.key,
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    const link = document.createElement('a')
                    link.setAttribute('href', res.data.data.get_url)
                    link.click()
                    return
                }
                this.$message.error('下载失败' + res.data.msg)
            })
        },
        Getapp() {
            this.api.ClientList({
                page: 1,
                limit: 100,
            }).then(res => {
                if (res.data.code == 200) {
                    this.brandlist = res.data.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        GetTuyaList() {
            this.api.UserTuyaList({
                uid: this.uid,
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.tuyalist = res.data.data
                    this.GetBindDevice()
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        changePushType(item) {
            return util.handleValueDisplay(this.pushType, item)
        },
        Looktoken(item) {
            this.tokenform.token = item
            this.tokenFormVisible = true
        },
        changeStatus(type, item, status) {
            let paramType = ''
            let paramVal = ''
            if (type == 'auth_tow' && status) {
                paramVal = null
            } else if (status) {
                paramVal = 0
            } else {
                paramVal = 1
            }
            if (type == 'active_push') {
                paramType = 'ActivePush'
            }
            if (type == 'auth_tow') {
                paramType = 'FactorAuth'
            }
            if (type == 'is_debug') {
                paramType = 'Debug'
            }
            if (type == 'is_developer') {
                paramType = 'Developer'
            }
            if (type == 'is_test') {
                paramType = 'Test'
            }
            this.api.UserAppStatus({
                change_type: paramType,
                uid: item.uid,
                value: paramVal,
                schema: item.schema,
            }, {
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('状态修改成功')
                    this.GetUserAppList()
                    return
                }
                this.$message.error('状态修改失败' + res.data.msg)
            })
        },
        statusValidate(call) {
            this.$refs['statusform'].validate(res => {
                if (res && call) {
                    call()
                }
            })
        },
        statusconfirm() {
            this.api.UserAppStatus({
                change_type: this.statusform.change_type,
                uid: this.statusform.uid,
                value: this.statusform.change_type == 'FactorAuth' ? null : this.statusform.value,
                schema: this.statusform.schema,
            }, {
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('状态修改成功')
                    this.statusFormVisible = false
                    this.GetUserAppList()
                    return
                }
                this.$message.error('状态修改失败' + res.data.msg)
            })
        },
        prePage() {
            if (this.search.page - 1 !== 0) {
                this.search.page = this.search.page - 1
                this.GetUserAppList()
            } else {
                this.predisabled = true
            }
        },
        nextPage() {
            this.search.page = this.search.page + 1
            this.GetUserAppList('next')
        },
        GetUserInfo() {
            this.api.UserManageDetail({
                uid: this.uid,
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.form = res.data.data.migrage_user
                    this.schema = res.data.data.migrage_user.schema
                    this.userPackageSearchAppId = this.schema
                    this.userform = res.data.data.user
                    this.form.create_time = util.dateFormat(res.data.data.migrage_user.create_time)
                    this.userform.register_time = util.dateFormat(res.data.data.user.register_time)
                    this.userform.delete_time = util.dateFormat(res.data.data.user.delete_time)
                    this.userform.update_time = util.dateFormat(res.data.data.user.update_time)
                    this.userform.register_ip = util.toIP(res.data.data.user.register_ip)
                    this.alexa = res.data.data.alexa
                    this.google_home = res.data.data.google_home
                    this.GetUserPackageList()
                    this.GetLoginList()
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        GetLoginList() {
            this.api.UserLoginList({
                page: 1,
                limit: 100,
                uid: this.uid,
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.loginlist = res.data.data
                    this.GetTrustDevList()
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        GetTrustDevList() {
            this.api.UserTrustDevList({
                page: 1,
                limit: 100,
                uid: this.uid,
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    this.trustDevlist = res.data.data
                    this.GetUserAppList()
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        GetUserAppList(item) {
            this.api.UserAppList({
                page: this.search.page,
                limit: this.search.limit,
                uid: this.uid,
                region: this.region
            }).then(res => {
                if (res.data.code == 200) {
                    if (res.data.data) {
                        this.predisabled = false
                        this.nextdisabled = false
                        this.list = res.data.data
                        if (this.search.page == 1) {
                            this.predisabled = true
                        }
                        if (this.list.length < this.search.limit) {
                            this.nextdisabled = true
                        }
                    } else if (item == 'next') {
                        this.nextdisabled = true
                    }
                    this.GetTuyaList()
                    return
                } else if (res.data.msg == '系统错误no data') {
                    this.predisabled = true
                    this.nextdisabled = true
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        getTslAttributeList() {
            this.api.TslAttributeList({
                page: 1,
                rows: 500
            }).then((res) => {
                if (res.data.code == 200) {
                    this.tslAttribute = res.data.data.data.reduce((prev, cur) => {
                        prev[cur.identifier] = cur
                        return prev
                    }, {})
                }
            })
        },
        closeDeviceShadowDialog() {
            this.deviceShadowDialog.visible = false
        },
        changeTime(item) {
            return util.dateFormat(item)
        },
        goback() {
            if (this.$route.params.uid.split('&')[2] == 'online') {
                this.$router.push('/iot/onlineinfo/' + this.$route.params.uid.split('&')[3])
            } else if (this.$route.params.uid.split('&')[2] == 'feedback') {
                this.$router.push('/iot/feedbackinfo/' + this.$route.params.uid.split('&')[3])
            } else if (this.$route.params.uid.split('&')[2] == 'tuya') {
                this.$router.push('/iot/tuya/')
            } else {
                // this.$router.push('/iot/user')
                this.$router.go(-1)
            }
        },
    },
    filters: {},
    mounted() {
        this.uid = this.$route.params.uid.split('&')[0]
        this.region = this.$route.params.uid.split('&')[1]
        this.params = this.$route.params.uid
        this.GetUserInfo()
    },
    created() {
        this.Getapp()
        this.getTslAttributeList()
        this.GetPackageLevelList()
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.page {
	float: right;
	margin-top: 10px
}
.box-card {
    margin-bottom: 30px;
}

.close_cloud {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.close_cloud_select {
	width: 100px;
	height: 30px;
	border-radius: 5px;
	margin-bottom: 20px;
}
.editor {
    height: 400px;
}
</style>
<style>
.el-dialog {
    padding-bottom: 10px;
}
.el-table__fixed-right {
    .el-table__row td.el-table__cell {
        background-color: #fff;
    }
}
.el-table .el-table__header th .cell {
    white-space: nowrap;
}
</style>
